import { Button, Popover, Space, Tag } from "antd";
import get from "lodash/get";
import { Typography } from "antd";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import {
  convertTimeRangeToAmPm,
  getTransformedMinutes,
} from "../../utilities/helpers";
const { Text, Paragraph } = Typography;
const cellStyle = {
  padding: "2px",
  paddingTop: "8px",
  paddingBottom: "8px",
  textAlign: "center",
};
export const getBreakdownColumns = (showEditModal, template_type = 1) => {
  switch (template_type) {
    case 1:
      return [
        {
          title: "Day Hours",
          dataIndex: "slot",
          key: "slot",
          width: "180px",
          onHeaderCell: () => ({
            style: { padding: "4px", textAlign: "center" },
          }),
          onCell: () => ({
            style: cellStyle,
          }),
          render: (text) => (
            <Tag color="blue" className="min-w-max">
              {convertTimeRangeToAmPm(text)}
            </Tag>
          ),
        },
        {
          title: "Idle Time",
          dataIndex: ["meta", "idle_time"],
          key: "idle_time",
          width: "200px",
          onHeaderCell: () => ({
            style: { padding: "4px", textAlign: "center" },
          }),
          onCell: () => ({
            style: cellStyle,
          }),
          render: (text) => (
            <Text>{getTransformedMinutes(Number(text || 0))}</Text>
          ),
        },
        {
          title: "Off Time",
          dataIndex: ["meta", "off_time"],
          key: "off_time",
          width: "200px",
          onHeaderCell: () => ({
            style: { padding: "4px", textAlign: "center" },
          }),
          onCell: () => ({
            style: cellStyle,
          }),
          render: (text) => (
            <Text>{getTransformedMinutes(Number(text || 0))}</Text>
          ),
        },
        {
          title: "Reason",
          dataIndex: "break_down_reason",
          key: "reason",
          width: "50%",
          onHeaderCell: () => ({
            style: { padding: "4px", textAlign: "center" },
          }),
          onCell: () => ({
            style: cellStyle,
          }),

          render: (reason, record) => {
            if (get(reason, "reason")) {
              return (
                <div className="flex items-center w-[100%] justify-center">
                  <Popover
                    placement="leftTop"
                    content={get(record, "break_down_description", "--")}
                    overlayStyle={{ maxWidth: "400px" }}
                  >
                    {" "}
                    <Tag
                      color="purple"
                      className="text-center mb-0 max-w-[400px] p-1 min-w-[200px]"
                    >
                      {get(reason, "reason", "--") || reason}
                    </Tag>
                  </Popover>
                </div>
              );
            } else {
              return <Text>--</Text>;
            }
          },
        },
        {
          title: "Action",
          key: "action",
          width: "160px",
          onHeaderCell: () => ({
            style: { padding: "4px", textAlign: "center" },
          }),
          onCell: () => ({
            style: cellStyle,
          }),
          render: (_, record) => (
            <Space size="middle">
              {get(record, "break_down_reason.reason") ? (
                <Button
                  type="link"
                  icon={<EditOutlined />}
                  onClick={() => showEditModal(record)}
                  className="text-blue-600 hover:text-blue-800"
                >
                  Edit Breakdown
                </Button>
              ) : (
                <Button
                  type="link"
                  icon={<PlusOutlined />}
                  onClick={() => showEditModal(record)}
                  className="text-blue-600 hover:text-blue-800"
                >
                  Add Breakdown{get(record, "reason")}
                </Button>
              )}
            </Space>
          ),
        },
      ];
  }
};
